import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, NavParams } from 'ionic-angular';
import * as moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { AdvancedAnalyticsServices } from '../../advanced-analytics-services';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';

/**
 * Generated class for the AnalyticsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-reservations-avg-persons-per-stripe-per-day',
  templateUrl: 'reservations-avg-persons-per-stripe-per-day.html',
})
export class ReservationsAvgPersonsPerStripePerDayPage {

  public chartData: any;
  public chartLabels: any;
  public chartCheck: any;
  result: any;
  //datatable
  rows = [];
  temp = [];
  columns = [
    { prop: 'DATE', name: this.translate.instant('general-fecha') },
    { prop: 'STRIPE_1_PERSONS', name: this.translate.instant('general-manana-n-comensales') },
    { prop: 'STRIPE_1_COUNT', name: this.translate.instant('general-manana-n-reservas') },
    { prop: 'STRIPE_2_PERSONS', name: this.translate.instant('general-mediodia-n-comensales') },
    { prop: 'STRIPE_2_COUNT', name: this.translate.instant('general-mediodia-n-reservas') },
    { prop: 'STRIPE_3_PERSONS', name: this.translate.instant('general-noche-n-comensales') },
    { prop: 'STRIPE_3_COUNT', name: this.translate.instant('general-noche-n-reservas') },

  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,
    public modalCtrl: ModalController) {
    this.getAnalyticsData();
  }

  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('analytics-titulo-fechas'),
      date_first: this.advancedAnalyticsServices.date1,
      date_last: this.advancedAnalyticsServices.date2,
      cash_bool: false,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.advancedAnalyticsServices.date1 = data.date_first;
        this.advancedAnalyticsServices.date2 = data.date_last;
        //
        this.getAnalyticsData();
      }
    });
    profileModal.present();
  }

  async getAnalyticsData() {

    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'));

    this.chartCheck = false;//boolean check
    this.http.post(this.globals.analytics_path + 'analytics/reservations_avg_persons_per_stripe_per_day', params, {})
      .subscribe(async response => {
        //total
        //this.result = response['TOTAL'];
        //grafica

        this.chartData = response['data_reservations']['data']; //total's
        this.chartLabels = response['data_reservations']['labels'];//Dates

        this.chartLabels[0] = this.translate.instant('general-franja-manana');
        this.chartLabels[1] = this.translate.instant('general-franja-mediodia');
        this.chartLabels[2] = this.translate.instant('general-franja-noche');

        //listado
        this.rows = response['list'];
        this.temp = response['list'];

        //
        this.chartCheck = true;//boolean check
      });

  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.date.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  export() {
    const formatedData = this.rows.map(x => ({
      'date': x.DATE,
      'Morning Persons': x.STRIPE_1_PERSONS,
      'Morning Total Reservations': x.STRIPE_1_COUNT,
      'Midday Persons': x.STRIPE_2_PERSONS,
      'Midday Total Reservations': x.STRIPE_2_COUNT,
      'Night Persons': x.STRIPE_3_PERSONS,
      'Night Total Reservations': x.STRIPE_3_COUNT,
    }));
    const params = new HttpParams()
      .set('data', JSON.stringify(formatedData))
      .set('date1', moment(this.advancedAnalyticsServices.date1).format('DD/MM/YYYY HH:mm:ss'))
      .set('date2', moment(this.advancedAnalyticsServices.date2).format('DD/MM/YYYY HH:mm:ss'))
      .set('extras', JSON.stringify({}));
    this.http.post(this.globals.analytics_path + 'export/analytics', params, {})
      .subscribe(async res => {
        if (this.globals.so_mobile) {
          window.location.assign(res['task']);
        } else {
          window.open(res['task'], '_blank');
        }
      });
  }

}


// WEBPACK FOOTER //
// ./src/pages/analytics/reports/reservations-avg-persons-per-stripe-per-day/reservations-avg-persons-per-stripe-per-day.ts